var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIArrowSmRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64645 3L0.93934 3.70711L5.58579 8.35355L0.93934 13L1.64645 13.7071L7 8.35355L1.64645 3Z",
    fill: "#82868C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIArrowSmRight);
export default __webpack_public_path__ + "static/media/i_arrow_sm_right.baa41b3b25c582c9cdbe91d0a51cc5d3.svg";
export { ForwardRef as ReactComponent };